import { useIntl } from 'react-intl';

export function useIndeedEndDateTypeOptions() {
  const intl = useIntl();

  return [
    {
      id: 'fixed',
      value: 'fixed',
      label: intl.formatMessage({ defaultMessage: 'Fixed end date' }),
      description: intl.formatMessage({
        defaultMessage:
          'If set, Indeed optimizes to spend the budget efficiently by this date and also ensures that the campaign doesn’t spend beyond the specified date even if there is budget remaining.',
      }),
    },
    {
      id: 'target',
      value: 'target',
      label: intl.formatMessage({ defaultMessage: 'Target end date' }),
      description: intl.formatMessage({
        defaultMessage:
          'If set, Indeed optimizes to spend the budget efficiently by this date, but the campaign may spend past this date if the campaign still has budget remaining.',
      }),
    },
  ];
}
